module.exports = __webpack_public_path__ + "img/neal-schaffer.png";